import SuperRepository from '../superRepository'

export default new (class PlayersReportsRepository extends SuperRepository {
  baseUri() {
    return 'player_report'
  }
  playerReportNotification = async () =>
    this.httpClient().get(`${this.baseUri()}/notification`)
  generalReport = async ({ signal, ...data }) =>
    this.httpClient().post(`${this.baseUri()}/general_report`, data, { signal })
  cpaRsPerformanceReport = async ({ signal, ...data }) =>
    this.httpClient().post(`${this.baseUri()}/cpa_rs_performance`, data, { signal })
  cohortAnalysis = async ({ signal, ...data }) =>
    this.httpClient().post(`${this.baseUri()}/cohort_analysis`, data, { signal })
  costsReportExport = async (data, params) =>
    this.httpClient().postFile(`${this.baseUri()}/cost_report`, data, params)
  xlsxImport = async (data, params) =>
    this.httpClient().postFile(`${this.baseUri()}/xlsx_import`, data, params)
})()